import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";

const STATUS_STEPS = [
  {
    key: "Processing",
    label: "Processing",
    statuses: ["Draft", "In-Progress"],
  },
  {
    key: "Transcribing",
    label: "Transcribing",
    statuses: ["In-Transcription"],
  },
  { key: "Scribing", label: "Scribing", statuses: ["In-Scribing"] },
  {
    key: "Coding",
    label: "Coding",
    statuses: ["Pending AI Coding", "Coding"],
  },
  { key: "Hold", label: "Hold", statuses: ["On-Hold"] },
  {
    key: "Other",
    label: "Other",
    statuses: ["Invalid Audio Duration", "Deleted"],
  },
  { key: "Completed", label: "Completed", statuses: ["Completed"] },
];

const COLOR_COMPLETED = "#b8ffb8"; // previous steps
const COLOR_CURRENT = "#00d8b4"; // active/current step
const COLOR_UPCOMING = "#b9b7a3"; // upcoming steps

const StatusProgressBar = ({ status }) => {
  const activeIndex = useMemo(() => {
    const idx = STATUS_STEPS.findIndex((step) =>
      step.statuses.includes(status)
    );
    if (idx === -1) return 0;
    return idx;
  }, [status]);

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          borderRadius: "10px",
          overflow: "visible", // allow current phase to pop out
          width: "100%",
          position: "relative",
        }}
      >
        {STATUS_STEPS.map((step, index) => {
          let bgColor = COLOR_UPCOMING;

          if (index < activeIndex) {
            bgColor = COLOR_COMPLETED;
          } else if (index === activeIndex) {
            bgColor = COLOR_CURRENT;
          }

          const isActive = index === activeIndex;

          return (
            <Box
              key={step.key}
              sx={{
                flex: 1,
                bgcolor: bgColor,
                color: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                py: isActive ? 2 : 1.5, // taller
                px: 1,
                position: "relative",
                zIndex: isActive ? 2 : 1, // on top
                mt: isActive ? -0.5 : 0, // pop up a bit
                boxShadow: isActive ? "0px 2px 6px rgba(0,0,0,0.25)" : "none",
                borderRadius:
                  index === 0
                    ? "10px 0 0 10px"
                    : index === STATUS_STEPS.length - 1
                    ? "0 10px 10px 0"
                    : 0,
                "&:not(:last-of-type)::after": {
                  content: '""',
                  position: "absolute",
                  right: -20,
                  top: 0,
                  borderTop: `${isActive ? 28 : 24}px solid transparent`,
                  borderBottom: `${isActive ? 28 : 24}px solid transparent`,
                  borderLeft: `20px solid ${bgColor}`,
                  zIndex: 1,
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: isActive ? 600 : 400,
                  textAlign: "center",
                  px: 1,
                }}
              >
                {step.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default StatusProgressBar;
